import styled from "styled-components";
import Icon from "../../../../../components/icon";
import { theme } from "../../../../../helpers/theme";
import { ReactComponent as SuccessInfoSVG } from "../../../../../assets/icons/success-info.svg"
import { StyledButton } from "../../../../../components/Button/button";
import { useNavigate } from "react-router-dom";
import { urlOperator } from "../../../../../utils/url";


interface SubcontractorDataAddProps {
    warehouseSubcontractorConnection: boolean;
    handleReset: () => void;
}


export const DataSaved = ({
    warehouseSubcontractorConnection,
    handleReset,

}: SubcontractorDataAddProps) => {
    const navigate = useNavigate();

    return (
        <Container>
            <IconWraper>
                <Icon
                    width="200px"
                    height="200px"
                    noPadding
                    icon={<SuccessInfoSVG />}
                />
            </IconWraper>
            <MessageWraper>
                <TitleHeader>{
                    warehouseSubcontractorConnection
                        ? "Gratulacje!"
                        : " Upss..."}
                </TitleHeader>
                {
                    warehouseSubcontractorConnection
                        ? <Article>
                            Dane <strong>podwykonawcy</strong> i jego <strong>magazynu</strong> zostały pomyślnie zapisane w bazie.
                        </Article>
                        : <Article>
                            Coś poszło nir tak skontaktuj się z administratorem.
                        </Article>
                }
            </MessageWraper>
            <ButtonWraper>
                <StyledButton
                    sx={{
                        marginRight: "10px",
                        color: `${theme.colors.blue01_active}`,
                        backgroundColor: `${theme.colors.gray04_background}`,
                        border: `1px solid ${theme.colors.blue01_active}`,
                        '@media(max-width:350px)': {
                            width: '100px',
                            marginLeft: '32px',
                        },
                        "&:hover": {
                            backgroundColor: `${theme.colors.blue01_active}`,
                            color: "white",
                        },
                    }}

                    onClick={() => handleReset()}
                >Dodaj kolejnego podwykonawcę
                </StyledButton>
                <StyledButton
                    onClick={() => navigate(urlOperator.subcontractors)}
                    sx={{

                    }}>
                    Zakończ
                </StyledButton>
            </ButtonWraper>

        </Container >
    );
};
const Container = styled.div`
width:100%;
font-family:${theme.fonts.interMedium},
`;

const TitleHeader = styled.div`
font-family:  ${theme.fonts.interRegular};
font-style: normal;
font-weight: 700;
font-size: 24px;
line-height: 32px;
text-align: center;
color: ${theme.colors.black_primaryText};`;

const Article = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 20px;
text-align: center;
color: ${theme.colors.gray01_secondaryText};
max-width: 300px;
align-self: center;
margin-top:24px;
`;
const IconWraper = styled.div`
display:flex;
flex-direction:row;
justify-content: center;
padding:32px 16px;
`;
const MessageWraper = styled.div`
display:flex;
flex-direction:column;
//margin-bottom:36px;
`;
const ButtonWraper = styled.div`
display:flex;
flex-direction:row;
justify-content: center;
padding:32px 16px;
row-gap:10px;
margin-bottom:32px;
`